export default __webpack_public_path__ + "static/media/bca-raffle-arrow-left.7c8dc907.png";